module.exports = __webpack_public_path__ + "img/roedkaal_done.023dcaf6.jpg";